import React from "react";
import { useTranslation } from "react-i18next";
import Card from "react-bootstrap/Card";
import { getMultiLangProperty } from "../../../helpers/generalHelper";

const ShopCategoryDescription = ({ selectedCategory }) => {
  const { i18n } = useTranslation();

  if (
    !selectedCategory ||
    !selectedCategory.description ||
    !getMultiLangProperty(selectedCategory.description, i18n.language) ||
    getMultiLangProperty(selectedCategory.description, i18n.language) ===
      "<p></p>\n"
  )
    return null;
  return (
    <Card
      style={{
        marginTop: 10,
        marginBottom: 40,
        padding: 10,
        boxShadow: "0 4px 8px 0 rgba(0,0,0,0.2)",
      }}
    >
      {Array.isArray(selectedCategory.media) &&
        selectedCategory.media.length > 0 &&
        selectedCategory.media[0].fileUrl && (
          <img
            src={selectedCategory.media[0].fileUrl}
            style={{
              objectFit: "contain",
              width: "100%",
              maxHeight: 200,
              marginBottom: 20,
            }}
          />
        )}
      {getMultiLangProperty(selectedCategory.description, i18n.language) && (
        <div
          className="html-content"
          dangerouslySetInnerHTML={{
            __html: getMultiLangProperty(
              selectedCategory.description,
              i18n.language
            ),
          }}
        />
      )}
    </Card>
  );
};

export default ShopCategoryDescription;
